global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Headroom from "headroom.js";

import Swiper from 'swiper/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/bundle';
window.Swiper = Swiper;

import AOS from 'aos';
import 'aos/dist/aos.css';

$(document).ready(function() {
    $(function() {
        AOS.init({
            duration: 800,
            offset: 50,
            delay: 400,
            // mirror: true,
            once: true,
        });
    });
    // To-top button
    const toTopBtn = $('#to-top');
    $(window).scroll(function(){
        if ($(window).scrollTop() > 300) {
            toTopBtn.fadeIn();
        } else {
            toTopBtn.fadeOut();
        }
    });

    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });


    function getDeviceType() {
        const userAgent = navigator.userAgent.toLowerCase();
        const isTouchDevice = navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
        const screenWidth = window.innerWidth;

        // Apple Devices
        const isIPhone = /iphone/i.test(userAgent);
        const isIPad = /ipad/i.test(userAgent) || (navigator.platform === "MacIntel" && isTouchDevice); // Per iPadOS
        const isApple = isIPhone || isIPad;

        // Android & Other Tablets/Mobile
        const isAndroid = /android/i.test(userAgent);
        const isTablet = /ipad|android(?!.*mobile)|tablet|playbook|silk|kindle/i.test(userAgent) ||
            (screenWidth >= 600 && screenWidth <= 1360 && isTouchDevice && !isApple);
        const isMobile = /iphone|ipod|android.*mobile|windows phone|blackberry/i.test(userAgent) ||
            (screenWidth < 600 && isTouchDevice);

        if (isApple) return "Apple";
        if (isTablet) return "Other Tablet";
        if (isMobile) return "Other Mobile";
        return "Desktop";
    }

    if($('.headroom').length > 0){
        let device = getDeviceType();
        let headroomEl = document.querySelector("header");
        let logoNegative = document.querySelector(".logo-negative");
        let logoDefault = document.querySelector(".logo-default");
        let options = {
            offset: 50
        };
        if (window.innerWidth < 992) {
            options = {
                offset : 50,
                // onPin : function() {
                //     headroomEl.classList.add('negative-navbar');
                //     logoNegative.classList.remove('d-none');
                //     logoDefault.classList.add('d-none');
                // },
                // onTop : function() {
                //     headroomEl.classList.remove('negative-navbar');
                //     logoNegative.classList.add('d-none');
                //     logoDefault.classList.remove('d-none');
                // },
                // onNotTop : function(e) {
                //     headroomEl.classList.add('negative-navbar');
                //     logoNegative.classList.remove('d-none');
                //     logoDefault.classList.add('d-none');
                // }
            };
        } else {
            options = {
                offset : 50,
                // onPin : function() {
                //     headroomEl.classList.add('negative-navbar');
                // },
                // onTop : function() {
                //     headroomEl.classList.remove('negative-navbar');
                // },
                // onNotTop : function(e) {
                //     headroomEl.classList.add('negative-navbar');
                // }
            };
        }

        let headroom  = new Headroom(headroomEl,options);
        headroom.init();
    }




    if (getDeviceType() == "Apple") {
        if($("#indicazioni a")) {
            $("#indicazioni a").attr("href", "https://maps.apple.com/?address=Via%20della%20Crusca%2027,%2030173%20Mestre,%20Venezia,%20Italia");
        }
    } else {
        if($("#indicazioni a")) {
            $("#indicazioni a").attr("href","https://maps.app.goo.gl/pSDBfXFtCcN3Tmfw5");
        }
    }
});
